import Headers from "../../config/headers";
import ApiCalls from "../../config/apiCalls";

export default {
  namespaced: true,
  state: {
    showNpsCsatFeedback: false,
    eventId: "",
    homeWidgetId: "",
    type: "",
    orderId: "",
    items: [],
    sortedItems: [],
    deliveryTimestamp: "",
    userId: "",
    title: "",
    deliveryOrderType: "",
    npsZeroRating: "",
    npsTenRating: "",
  },
  getters: {},
  mutations: {
    updateNpsCsatModalFlag(state, payload) {
      state.showNpsCsatFeedback = payload;
    },
    updateItems(state, payload) {
      state.items = payload;
    },
    updateFeedbackType(state, payload) {
      state.type = payload;
      commit("sortItems", payload);
    },
    updateData(state, payload) {
      const { order = {} } = payload;
      state.eventId = payload?.eventId || "";
      state.homeWidgetId = payload?.homeWidgetId || "";
      state.type = payload?.type || "";
      state.userId = payload?.userId || "";
      if(order?.items?.length > 0) {
        let { items = [], deliveryTimeStamp = "" } = order;
        state.items = items.sort((a,b) => b.price - a.price);
        state.deliveryTimestamp = deliveryTimeStamp;
      }
      state.title = payload?.title || "";
      state.orderId = payload?.orderId;
      state.deliveryOrderType = payload?.order?.deliveryOrderType?.deliveryTypeCode || "";
      state.npsZeroRating = payload?.npsZeroRating || "";
      state.npsTenRating = payload?.npsTenRating || "";
    }
  },
  actions: {
    getHomeWidget({commit}, payload) {
      ApiCalls.GET_NPS_CSAT_HOME_WIDGET({
        headers: {
          ...Headers(),
          mobile: payload.mobile
        }
      })
      .then((res) => {
        if(res?.data) {
          const data = res?.data || {};
          if(Object.keys(data).length > 0) {
            commit("updateData", data);
            commit("updateNpsCsatModalFlag", true);
          }
        }
      }).catch(err => {
        console.error(err);
      })
    },
    dismissHomeWidget({commit}, payload) {
      ApiCalls.NPS_CSAT_DISMISS_HOME_WIDGET({
        headers: Headers(),
        payload: payload
      }).then().catch(err => {
        console.error(err);
      })
    }
  }
}
